import React, { Component } from 'react';
import { Card, CardBody, CardGroup, Col, Container, Row } from 'reactstrap';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import { Login } from '../../Pages';
import LateFeeCalculator from '../../../lateFeeCalculator';
import labelPrinter from '../../../labelPrinter';

import MainNav from '../../../headers/PublicHeader';


class Landing extends Component {

  renderIndex() {
    return (
      <div>
        <div className="app flex-row align-items-center">
          <Container>
            <Row className="justify-content-center">
              <Col md="6">
                <CardGroup>
                  <Card className="p-4">
                    <CardBody>
                      <h1>Welcome</h1>
                    </CardBody>
                  </Card>
                </CardGroup>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
  }

  render() {
    return (
      <Router>
        <div>
          <MainNav isOpen={false} />
          <Switch>
            <Route exact path="/" render={this.renderIndex}/>
            <Route exact path="/signin" component={Login}/>
            <Route exact path="/lateFeeCalculator" component={LateFeeCalculator}/>
            <Route exact path="/dscLabelPrinter" component={labelPrinter}/>
            <Route render={props => <Redirect to={`/signin?next=${props.location.pathname}`} />} />
          </Switch>
        </div>
      </Router>
    );
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/views/Pages/Landing/Landing.js